export function ignoreTouchesWhenSwiping(gallery: HTMLElement) {
  let startX = 0
  gallery.addEventListener(
    'touchstart',
    (e: TouchEvent) => {
      const touch = e.touches[0]
      if (touch) {
        startX = touch.clientX
      }
    },
    { passive: true },
  )
  gallery.addEventListener(
    'touchmove',
    (e: TouchEvent) => {
      const touch = e.touches[0]
      if (touch && Math.abs(touch.clientX - startX) > 5 && e.cancelable) {
        e.preventDefault()
      }
    },
    { passive: false },
  )
}
